export const azureNodesData = {
  // Workload section items
  workloadItems: [
    { iconName: "app-gateway", label: "Application Gateway", color: "#7FBA00" },
    { iconName: "app-service", label: "App Service", color: "#0078D4" },
    { iconName: "web-app", label: "Web App", color: "#0078D4" },
    { iconName: "web-app-worker", label: "Web App Worker pools", color: "#0078D4" },
    { iconName: "web-app-firewall", label: "Web App Firewall", color: "#D83B01" },
    { iconName: "load-balancer", label: "Load Balancers", color: "#7FBA00" },
    { iconName: "bastion-host", label: "Bastion host", color: "#7FBA00" },
    { iconName: "app-insights", label: "Application Insights", color: "#8661C5" },
    { iconName: "sql-database", label: "Azure SQL Database", color: "#0078D4" },
    { iconName: "mgmt-portal", label: "Azure Management Portal", color: "#0078D4" },
  ],

  // Veritran Components
  identityItems: [
    { iconName: "security-suite", label: "Security Suite", color: "#0b172d" },
    { iconName: "gateway", label: "Gateway", color: "#5680b0" },
    { iconName: "balancer", label: "Balancer", color: "#3f6b88" },
    { iconName: "st", label: "Veritran Studio Low Code", color: "#858585" },
    { iconName: "push-notification", label: "Push Notification", color: "#5680b0" },
      { iconName: "hcms", label: "HCMS", color: "#858585" },
    { iconName: "geolocation", label: "GeoLocation", color: "#3f6b88" },
    { iconName: "idm", label: "Identity Manager", color: "#0b172d" },
    { iconName: "brm", label: "Business Rule Management", color: "#858585" },
    { iconName: "as", label: "Authentication Server", color: "#3f6b88" },
    { iconName: "st", label: "Veritran Studio Low Code", color: "#0b172d" },
    { iconName: "ia", label: "IA Engine", color: "#5680b0" },

  ],

  // 3rd Parties involved
  systemHealthItems: [
    { iconName: "mb", label: "Mambu", color: "#7FBA00" },
    { iconName: "fc", label: "Facetec", color: "#0078D4" },
    { iconName: "ve", label: "Veridas", color: "#8661C5" },
    { iconName: "tw", label: "Twillio", color: "#D83B01" },
    { iconName: "gl", label: "Glia", color: "#FFB900" },
    { iconName: "sw", label: "Swift", color: "#00BCF2" },
  ],

  // Networking items
  networkingItems: [
    { iconName: "storage", label: "Azure Storage", color: "#0078D4" },
    { iconName: "expressroute", label: "ExpressRoute", color: "#7FBA00" },
    { iconName: "vpn-gateway", label: "VPN Gateway", color: "#0078D4" },
  ],

  // Left side items
  leftSideItems: [
    { iconName: "dns-lookup", label: "DNS Lookup", color: "#00BCF2" },
    { iconName: "users", label: "Users", color: "#00BCF2" },
    { iconName: "azure-dns", label: "Azure DNS", color: "#0078D4" },
    { iconName: "systems-eng", label: "Systems engineering", color: "#00BCF2" },
  ],
};

// Mapping for onboarding steps to icon names
export const onboardingIconMap = {
  ONB_TYC: "terms",
  ONB_EMAIL: "email",
  ONB_SMS: "sms",
  ONB_DOCUMENT_ID: "id-card",
  ONB_BIOMETRICS: "fingerprint",
  ONB_CREDENTIALS: "key",
  ONB_PRODUCT_SELECTION: "shopping-cart",
  ONB_COMPANY_DATA: "building",
  ONB_UPLOAD_DOCUMENTS: "upload",
  ONB_POSTONBOARDING: "settings",
  ONB_VIDEORECORDING: "video",
  ONB_CHECKOUT: "checkout",
};

// Mapping for features to icon names
export const featureIconMap = {
  GLOBAL_TRANSFERS: "globe",
  GOALS: "target",
  VERITOKS: "token",
  SEND_MONEY: "send",
  REQUEST_MONEY: "request",
  QR_PAYMENTS: "qr-code",
  TAP_TO_PHONE: "phone-tap",
  LOYALTY: "star",
  RECHARGE: "battery",
  INVESTMENTS: "chart-up",
  DYNAMIC_CVV: "credit-card",
  PAYEES: "bill",
  DATA_ENRICHMENT: "database",
  TOP_UP: "plus-circle",
  ATM: "atm",
  DYNAMIC_CONTENT: "content",
  ACCOUNTS: "wallet",
  PAYMENTS: "payment",
  CARDS: "cards",
  DEPOSIT_CHECKS: "check",
  PROFILE: "user",
  INVESTING: "investment",
  PAY_BILLS: "bill-payment",
  CNEX: "cnex",
  DOMESTIC_TRANSFERS: "transfer",
  WIRED_TRANSFER: "wire",
  LOCAL_CURRENCY: "currency",
  DEBIT_CARD: "debit",
  TRANSFERS_AND_PAYMENTS: "transfer-pay",
  FOREIGN_CURRENCY: "foreign-currency",
  CHARGING_STORES: "store",
  SUPPLIERS_PAYMENT: "supplier",
  COLLECTIONS: "collection",
  INVESTMENTS_BUSINESS: "business-investment",
  CREDIT_CARD: "credit",
  INSURANCE: "shield",
  LOANS: "loan",
  CORPORATE_BANKING: "bank",
  AGREEMENT_ACCOUNT: "agreement",
  PAYROLL: "payroll",
  CHECKBOOK: "checkbook",
  TAP_TO_CONFIRM: "tap-confirm",
  TAP_TO_P2P: "tap-p2p",
  CARD_TO_CARD: "card-transfer",
  PUSH_PROVISIONING: "push",
  WALLET_EXTENSION: "wallet-ext",
  DIGITAL_CARD_DISPLAY: "digital-card",
  SPLIT_PAYMENTS: "split",
  OFFLINE_PAYMENTS: "offline",
  CLICK_TO_PAY: "click-pay",
  TAP_TO_EVERYTHING: "tap-all",
  TOKENIZATION_EFFORTLESS: "tokenize",
  CAMPUS_VIRTUAL: "campus",
  BOOKSTORE: "bookstore",
  TRANSPORT_PASS: "transport",
  NOTIFICATIONS: "bell",
};

export const line3Conditions = [
  { param: "hasdigitalonboarding", code: "DIGITAL_ONBOARDING" },
  { param: "hasmarketreview", code: "MARKET_REVIEW" },
  { param: "hasglobaltransfer", code: "GLOBAL_TRANSFER" },
  { param: "hasaccountsmanager", code: "ACCOUNTS_MANAGER" },
  { param: "hassecurelinks", code: "SECURE_LINKS" },
  { param: "hasglobaltransfers", code: "GLOBAL_TRANSFERS" },
  { param: "hasgoals", code: "GOALS" },
  { param: "hasveritoks", code: "VERITOKS" },
  { param: "hassendmoney", code: "SEND_MONEY" },
  { param: "hasrequestmoney", code: "REQUEST_MONEY" },
  { param: "hasqrpayments", code: "QR_PAYMENTS" },
  { param: "hasdynamiccvv", code: "DYNAMIC_CVV" },
  { param: "hasdataenrichment", code: "DATA_ENRICHMENT" },
  { param: "hastaptophone", code: "TAP_TO_PHONE" },
  { param: "hastaptoconfirm", code: "TAP_TO_CONFIRM" },
  { param: "hastaptop2p", code: "TAP_TO_P2P" },
  { param: "hascardtocard", code: "CARD_TO_CARD" },
  { param: "haspushprovisioning", code: "PUSH_PROVISIONING" },
  { param: "haswalletextension", code: "WALLET_EXTENSION" },
  { param: "hasdigitalcarddisplay", code: "DIGITAL_CARD_DISPLAY" },
  { param: "hasclicktopay", code: "CLICK_TO_PAY" },
  { param: "hastaptoeverything", code: "TAP_TO_EVERYTHING" },
  { param: "hastokenizationeffortless", code: "TOKENIZATION_EFFORTLESS" },
  { param: "hasloyalty", code: "LOYALTY" },
  { param: "haspayees", code: "PAYEES" },
  { param: "hasrecharge", code: "RECHARGE" },
  { param: "hasdynamiccontent", code: "DYNAMIC_CONTENT" },
  { param: "hasinvestments", code: "INVESTMENTS" },
  { param: "hasatm", code: "ATM" },
  { param: "hastopup", code: "TOP_UP" },
  { param: "hasaccounts", code: "ACCOUNTS" },
  { param: "haspayments", code: "PAYMENTS" },
  { param: "hascards", code: "CARDS" },
  { param: "hasdepositcheck", code: "DEPOSIT_CHECKS" },
  { param: "hasprofile", code: "PROFILE" },
  { param: "hasinvesting", code: "INVESTING" },
  { param: "haspaybills", code: "PAY_BILLS" },
  { param: "hascnex", code: "CNEX" },
  { param: "hasdomestictransfer", code: "DOMESTIC_TRANSFERS" },
  { param: "haswiredtransfer", code: "WIRED_TRANSFER" },
  { param: "haslocalcurrency", code: "LOCAL_CURRENCY" },
  { param: "hasdebitcard", code: "DEBIT_CARD" },
  { param: "hastransfersandpayments", code: "TRANSFERS_AND_PAYMENTS" },
  { param: "hasforeigncurrency", code: "FOREIGN_CURRENCY" },
  { param: "haschargingstores", code: "CHARGING_STORES" },
  { param: "hassupplierspayment", code: "SUPPLIERS_PAYMENT" },
  { param: "hascollections", code: "COLLECTIONS" },
  { param: "hasinvestmentsbusiness", code: "INVESTMENTS_BUSINESS" },
  { param: "hascreditcard", code: "CREDIT_CARD" },
  { param: "hasinsurance", code: "INSURANCE" },
  { param: "hasloans", code: "LOANS" },
  { param: "hascorporatebanking", code: "CORPORATE_BANKING" },
  { param: "hasagreementaccount", code: "AGREEMENT_ACCOUNT" },
  { param: "haspayroll", code: "PAYROLL" },
  { param: "hascheckbook", code: "CHECKBOOK" },
  { param: "hassplitpayment", code: "SPLIT_PAYMENTS" },
  { param: "hasofflinepayments", code: "OFFLINE_PAYMENTS" },
  { param: "hasticketmanager", code: "TICKET_MANAGER" },
  { param: "hasqraccess", code: "QR_ACCESS" },
  { param: "hasstadiumaccess", code: "STADIUM_ACCESS" },
  { param: "hascampusvirtual", code: "CAMPUS_VIRTUAL" },
  { param: "hasbookstore", code: "BOOKSTORE" },
  { param: "hastransportpass", code: "TRANSPORT_PASS" },
  { param: "hasnotifications", code: "NOTIFICATIONS" },
];
